export enum OrderViewTabs {
  OFFER = 'offer',
  EVENTS = 'events',
  COMMENTS = 'comments',
  MARGIN = 'margin',
  Preparation = 'Klargjøring',
}
